import { Outlet, useLocation } from 'react-router-dom'
import authImageLogin from '@assets/images/image_01.png'
import authImageLoginPhone from '@assets/images/image_02.png'
import authImageRegister from '@assets/images/image_03.png'
import { useState, useEffect } from 'react'
import Header from '@components/common/Header'

function AuthLayout() {
  const location = useLocation()
  const isRegisterPage = location.pathname.includes('/register')
  const isForgotPasswordPage = location.pathname.includes('/forgot-password')
  const isPhoneVerificationPage = location.pathname.includes('/phone-verification')
  const [loginMethod, setLoginMethod] = useState('email')

  useEffect(() => {
    const handleStorageChange = () => {
      const method = localStorage.getItem('loginMethod') || 'email'
      setLoginMethod(method)
    }

    handleStorageChange()
    window.addEventListener('storage', handleStorageChange)
    window.addEventListener('loginMethodChange', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('loginMethodChange', handleStorageChange)
    }
  }, [])

  const panel = isRegisterPage
    ? { eyebrow: 'Inscription gratuite', title: 'Vendez plus, touchez vos clients.', points: ['Inscription en 1 minute', 'Période d\'essai offerte', 'Paiement avec Wave'] }
    : isForgotPasswordPage || isPhoneVerificationPage
      ? { eyebrow: 'Sécurité du compte', title: 'Récupérez l\'accès à votre compte.', points: ['Vérification sécurisée', 'Nouveau mot de passe', 'Accès immédiat'] }
      : { eyebrow: 'Bon retour', title: 'Content de vous revoir sur KUDHI.', points: ['Vos messages', 'Vos statistiques', 'Vos publications'] }

  let authImage = authImageLogin
  if (isRegisterPage) {
    authImage = authImageRegister
  } else if (isPhoneVerificationPage) {
    authImage = authImageLoginPhone
  } else if (isForgotPasswordPage) {
    authImage = authImageLogin
  } else if (loginMethod === 'phone') {
    authImage = authImageLoginPhone
  }

  return (
    // Hauteur fixée à l'écran : la page elle-même ne défile pas
    <div className="home-font h-screen flex flex-col overflow-hidden bg-white">
      <Header />
      <div className="flex flex-1 min-h-0">
        {/* Partie gauche : image dans une carte arrondie avec message */}
        <div className="hidden lg:block lg:w-1/2 p-4">
          <div className="relative h-full overflow-hidden rounded-md bg-gradient-to-br from-pink-200 via-pink-300 to-orange-200 shadow-[0_20px_50px_-20px_rgba(0,42,78,0.35)]">
            <img
              key={authImage}
              src={authImage}
              alt="KUDHI Authentication"
              className="absolute inset-0 w-full h-full object-cover animate-fade-in"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#001A33]/90 via-[#002A4E]/25 to-transparent" />

            {/* Étiquette haut */}
            <div className="absolute left-6 top-6 inline-flex items-center gap-2 rounded-full border border-white/20 bg-[#002A4E]/60 px-4 py-2 text-sm font-semibold text-white shadow-lg backdrop-blur-md">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#FFD700] opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-[#FFD700]" />
              </span>
              La plateforme d&apos;annonces N°1 en Côte d&apos;Ivoire
            </div>

            {/* Message bas */}
            <div className="absolute inset-x-0 bottom-0 p-8 xl:p-10">
              <p className="text-sm font-bold uppercase tracking-widest text-[#FFD700]">{panel.eyebrow}</p>
              <h2 className="mt-2 max-w-md text-3xl xl:text-4xl font-extrabold leading-tight tracking-tight text-white">{panel.title}</h2>
              <div className="mt-5 flex flex-wrap gap-2">
                {panel.points.map((p) => (
                  <span key={p} className="inline-flex items-center gap-1.5 rounded-full border border-white/25 bg-white/15 px-3 py-1.5 text-xs font-semibold text-white backdrop-blur-md">
                    <svg className="h-3.5 w-3.5 text-[#FFD700]" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                    </svg>
                    {p}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Partie droite avec formulaire */}
        <main
          className="flex-1 flex justify-center overflow-y-auto px-5 sm:px-8 py-6"
        >
          <div className="w-full max-w-md self-center">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}

export default AuthLayout
